/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Networks_List_Region_AllInputs */

const fr_networks_list_region_all = /** @type {(inputs: Networks_List_Region_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Toutes les régions`)
};

const en_networks_list_region_all = /** @type {(inputs: Networks_List_Region_AllInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`All regions`)
};

/**
* | output |
* | --- |
* | "All regions" |
*
* @param {Networks_List_Region_AllInputs} inputs
* @param {{ locale?: "fr" | "en" }} options
* @returns {LocalizedString}
*/
export const networks_list_region_all = /** @type {((inputs?: Networks_List_Region_AllInputs, options?: { locale?: "fr" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Networks_List_Region_AllInputs, { locale?: "fr" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_networks_list_region_all(inputs)
	return en_networks_list_region_all(inputs)
});